import { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import UserInfo from "./UserInfo";
import Barcode from "react-barcode";

// Function to draw rounded rectangle background
const drawRoundedBackground = (ctx, width, height, radius = 8, fillColor = "#ffffff") => {
  ctx.fillStyle = fillColor;
  ctx.beginPath();
  ctx.moveTo(radius, 0);
  ctx.lineTo(width - radius, 0);
  ctx.quadraticCurveTo(width, 0, width, radius);
  ctx.lineTo(width, height - radius);
  ctx.quadraticCurveTo(width, height, width - radius, height);
  ctx.lineTo(radius, height);
  ctx.quadraticCurveTo(0, height, 0, height - radius);
  ctx.lineTo(0, radius);
  ctx.quadraticCurveTo(0, 0, radius, 0);
  ctx.closePath();
  ctx.fill();
};

const GuestCoupon = (props) => {
  const { type } = props;
  const vipInfo = useSelector((state) => state.vip.vipInfo);
  const [isVipMember, setIsVipMember] = useState();
  const memberInfo = useSelector((state) => state.member.memberInfo);
  const { t } = useTranslation();
  const [barcode, setBarcode] = useState("");
  const [barcodeImageUrl, setBarcodeImageUrl] = useState("");
  const barcodeRef = useRef(null);

  useEffect(() => {
    if (memberInfo.coupon_no) {
      setBarcode(memberInfo?.coupon_no.replace(/-/g, ""));
    }
  }, [memberInfo]);

  useEffect(() => {
    if (barcode && barcodeRef.current) {
      const svgElement = barcodeRef.current.querySelector("svg");
      if (svgElement) {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        
        // Get SVG dimensions
        const svgWidth = svgElement.width.baseVal.value;
        const svgHeight = svgElement.height.baseVal.value;
        
        // Add white padding (16px on all sides)
        const padding = 16;
        canvas.width = svgWidth + padding * 2;
        canvas.height = svgHeight + padding * 2;
        
        // Draw rounded white background
        const borderRadius = 8;
        drawRoundedBackground(ctx, canvas.width, canvas.height, borderRadius);
        
        // Draw SVG to canvas
        const svgData = new XMLSerializer().serializeToString(svgElement);
        const img = new Image();
        img.onload = () => {
          ctx.drawImage(img, padding, padding);
          // Convert canvas to image URL
          const imageUrl = canvas.toDataURL("image/png");
          setBarcodeImageUrl(imageUrl);
        };
        img.src = "data:image/svg+xml;base64," + btoa(svgData);
      }
    }
  }, [barcode]);

  useEffect(() => {
    if (vipInfo?.isVip) {
      setIsVipMember(vipInfo?.isVip);
      setTimeout(() => {
        window.open(process.env.REACT_APP_BASE_VIP_URL, "_self");
      }, 5000);
    }
  }, [vipInfo]);

  return (
    <>
      {isVipMember ? (
        <div className="text-sm font-semibold leading-5 text-center text-red-500 max-w-[262px] mt-6">
          {t("vip_member_access")}
        </div>
      ) : (
        <>
          {barcodeImageUrl ? (
            <img 
              src={barcodeImageUrl} 
              alt="Barcode"
              style={{ display: "block", padding: "16px" }}
            />
          ) : (
            <div ref={barcodeRef} style={{ visibility: barcodeImageUrl ? "hidden" : "visible", position: barcodeImageUrl ? "absolute" : "relative" }}>
              <Barcode
                format="codabar"
                value={barcode}
                width={2.2}
                displayValue={false}
              />
            </div>
          )}
          <div className="text-sm">{memberInfo?.coupon_no}</div>
        </>
      )}
      <UserInfo />
    </>
  );
};

export default GuestCoupon;
